<script lang="ts" setup>
defineProps<{
  topics?: string[]
}>()
</script>

<template>
  <div class="m-topic">
    <RouterLink
      v-for="(t, i) in topics"
      :key="i"
      :to="`/tag/${t}`"
      target="_blank"
      class="m-topic-item"
    >
      {{ t }}
    </RouterLink>
  </div>
</template>

<style lang="scss" scoped>
.m-topic {
  height: 30px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  &-item {
    height: 24px;
    line-height: 24px;
    display: inline-flex;
    align-items: center;
    color: #666;
    border-radius: 4px;
    margin-right: 10px;
    margin-top: 5px;
    padding: 0 12px;
    background-color: var(--color-slate-200);
    position: relative;
    cursor: pointer;
  }
}
</style>
